import React from "react";
import Prompter from "./Prompter";

export default function EditPrompter() {
  return (
    <div
      className={`primary-card-background rounded-2xl overflow-hidden h-[calc(100vh-100px-60px)] md:h-[calc(100vh-100px-80px)] shadow-2xl z-50 transition-transform duration-500 flex translate-x-0`}
    >
      <Prompter />
    </div>
  );
}
